import React from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Form, Input, Label, Modal, ModalBody, ModalHeader, FormFeedback, Button } from 'reactstrap';
import { RestroUsers } from '../../../../services/DatabaseService/RestroUsers';
import { toast } from 'react-toastify';

const ContactPersonForm = ({ modalOpen, toggleModal, apiKey, onAdded }) => {
  console.log(apiKey)
  // Validation schema
  const validationSchema = Yup.object({
    contactPersonName: Yup.string().required("Name is required"),
    contactPersonEmail: Yup.string()
      .email("Invalid Email")
      .required("Email is required"),
    contactPersonPhone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
      .required("Phone Number is Required"),
    designation: Yup.string(),
    remarks: Yup.string()
  });

  // Formik
  const formik = useFormik({
    initialValues: {
      contactPersonName: "",
      contactPersonEmail: "",
      contactPersonPhone: "",
      designation: "",
      remarks: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          restroUsersInfoApiKey: apiKey,
          contactPersonName: values.contactPersonName,
          contactPersonEmail: values.contactPersonEmail,
          contactPersonPhone: values.contactPersonPhone,
          designation: values.designation,
          remarks: values.remarks
        };

        // Call API to add contact person
        await RestroUsers.AddContactPerson(payload);

        toast.success("Contact Person Added Successfully");
        toggleModal(); // Close the modal

        // Notify parent to refresh list if callback exists
        if (onAdded) onAdded();

      } catch (error) {
        console.error(error);
        toast.error("Failed to add contact person");
      }
    }
  });

  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      centered
      size="md"
      backdrop={true}
      contentClassName="p-3 rounded shadow-lg border-0"
    >
      <ModalHeader
        toggle={toggleModal}
        className="bg-gradient-primary text-white rounded-top shadow-sm"
        style={{ borderBottom: "2px solid #cecedbff" }}
      >
        Add Contact Person
      </ModalHeader>

      <Form onSubmit={formik.handleSubmit}>
        <ModalBody className='d-flex flex-column gap-3' style={{ maxHeight: '70vh', overflowY: 'auto' }}>

          {/* Name */}
          <div>
            <Label className="fw-bold">Name <span className="text-danger">*</span></Label>
            <Input
              name="contactPersonName"
              type="text"
              placeholder="Enter Name"
              value={formik.values.contactPersonName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.contactPersonName && formik.errors.contactPersonName)}
              className="shadow-sm rounded border border-secondary"
              style={{ transition: "0.3s", padding: "0.5rem" }}
            />
            {formik.touched.contactPersonName && formik.errors.contactPersonName && (
              <FormFeedback className="text-danger">{formik.errors.contactPersonName}</FormFeedback>
            )}
          </div>

          {/* Email */}
          <div>
            <Label className="fw-bold">Email <span className="text-danger">*</span></Label>
            <Input
              name="contactPersonEmail"
              type="email"
              placeholder="Enter Email"
              value={formik.values.contactPersonEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.contactPersonEmail && formik.errors.contactPersonEmail)}
              className="shadow-sm rounded border border-secondary"
              style={{ transition: "0.3s", padding: "0.5rem" }}
            />
            {formik.touched.contactPersonEmail && formik.errors.contactPersonEmail && (
              <FormFeedback className="text-danger">{formik.errors.contactPersonEmail}</FormFeedback>
            )}
          </div>

          {/* Phone */}
          <div>
            <Label className="fw-bold">Phone <span className="text-danger">*</span></Label>
            <Input
              name="contactPersonPhone"
              type="text"
              placeholder="Enter Phone"
              value={formik.values.contactPersonPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.contactPersonPhone && formik.errors.contactPersonPhone)}
              className="shadow-sm rounded border border-secondary"
              style={{ transition: "0.3s", padding: "0.5rem" }}
            />
            {formik.touched.contactPersonPhone && formik.errors.contactPersonPhone && (
              <FormFeedback className="text-danger">{formik.errors.contactPersonPhone}</FormFeedback>
            )}
          </div>

          {/* Designation */}
          <div>
            <Label className="fw-bold">Designation</Label>
            <Input
              name="designation"
              type="text"
              placeholder="Designation"
              value={formik.values.designation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={!!(formik.touched.designation && formik.errors.designation)}
              className="shadow-sm rounded border border-secondary"
              style={{ transition: "0.3s", padding: "0.5rem" }}
            />
            {formik.touched.designation && formik.errors.designation && (
              <FormFeedback className="text-danger">{formik.errors.designation}</FormFeedback>
            )}
          </div>

          {/* Remarks */}
          <div>
            <Label className="fw-bold">Remarks</Label>
            <Input
              name="remarks"
              type="textarea"
              placeholder="Enter any remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="shadow-sm rounded border border-secondary"
              style={{ transition: "0.3s", padding: "0.5rem" }}
            />
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-end mt-2">
            <Button
              type="submit"
              className="px-4 py-2 rounded shadow-sm"
              style={{
                backgroundColor: "#0d6efd",
                borderColor: "#0d6efd",
                transition: "0.3s",
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0b5ed7"}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#0d6efd"}
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Form>
    </Modal>
  )
}

export default ContactPersonForm;
